<mat-menu #menu="matMenu" class="mxs-dropdown_list" overlapTrigger="false">
    <button mat-menu-item
            type="button"
            [attr.aria-label]="getLabel('label.modify.account.change.password')"
            (click)="openChangePasswordDialog()">
        <mat-icon [attr.aria-label]="getLabel('label.modify.account.change.password')">vpn_key</mat-icon>
        <prl-label value="label.modify.account.change.password"/>
    </button>
    <button mat-menu-item
            type="button"
            [attr.aria-label]="getLabel('label.logout')"
            (click)="authService.logOut()">
        <mat-icon [attr.aria-label]="getLabel('label.logout')">logout</mat-icon>
        <prl-label value="label.logout"/>
    </button>
</mat-menu>
@if (authService.loggedInUser()) {
    <div class="mxs-header_username" [matTooltip]="getLabel('label.welcome') + ' ' + this.displayName" [matMenuTriggerFor]="menu">
        <div class="username-row">
            <span><prl-label value="label.welcome"/>, {{this.displayName}}</span>
            <i class="material-icons">account_circle</i>
        </div>
    </div>
}
